import PropTypes from 'prop-types';
import './Loading.css';

const Loading = ({ size = 'medium', variant = 'primary' }) => {
  return (
    <div className={`loading loading--${size} loading--${variant}`}>
      <div className="loading__spinner"></div>
    </div>
  );
};

Loading.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  variant: PropTypes.oneOf(['primary', 'secondary'])
};

export default Loading;
